import { styled } from "@monolith-forensics/monolith-ui";
import {
  DownloadIcon,
  MaximizeIcon,
  PencilIcon,
  Trash2Icon,
} from "lucide-react";
import { File } from "../../files.types";

const StyledContainer = styled.div`
  position: absolute;
  inset: 0;
  cursor: pointer;
  border-radius: 5px;
  background-color: transparent;
  transition: all 0.2s ease-in-out;
  border: 1px solid transparent;
  &:hover {
    background-color: #00000060;
    border: 1px solid ${({ theme }) => theme.palette.divider};
    .photo-buttons {
      opacity: 1;
    }
  }
  .photo-buttons {
    position: absolute;
    top: 0;
    right: 0;
    display: flex;
    margin: 10px;
    opacity: 0;
    transition: all 0.2s ease-in-out;
  }
  .photo-button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    border-radius: 5px;
    cursor: pointer;
    color: ${({ theme }) => theme.palette.text.primary};
    &:hover {
      background-color: ${({ theme }) => theme.palette.divider};
    }
    &.delete {
      color: ${({ theme }) => theme.palette.error.main};
    }
    svg {
      width: 15px;
      height: 15px;
    }
  }
`;

export type PhotoOverlayActionsProps = {
  file: File;
  onView: (file: File) => void;
  onDownload?: (file: File) => void;
  /** The delete button only renders when this is provided. */
  onDelete?: (file: File) => void;
  /** The rename button only renders when this is provided. */
  onRename?: (file: File) => void;
};

export const PhotoOverlayActions = ({
  file,
  onView,
  onDownload,
  onDelete,
  onRename,
}: PhotoOverlayActionsProps) => (
  <StyledContainer className="photo-overlay">
    <div className="photo-buttons">
      {onDelete && (
        <div
          className="photo-button delete"
          title="Delete Photo"
          onClick={() => onDelete(file)}
        >
          <Trash2Icon />
        </div>
      )}
      {onRename && (
        <div
          className="photo-button"
          title="Rename Photo"
          onClick={() => onRename(file)}
        >
          <PencilIcon />
        </div>
      )}
      <a
        href={file.link}
        download={file.name}
        onClick={() => onDownload?.(file)}
      >
        <div className="photo-button" title="Download">
          <DownloadIcon />
        </div>
      </a>
      <div
        className="photo-button"
        title="Full Screen"
        onClick={() => onView(file)}
      >
        <MaximizeIcon />
      </div>
    </div>
  </StyledContainer>
);
